import { NodeReference } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eDimensionAxis, eDimensionLineCapStyle } from '../enums';
import { Connector } from '../features/connector';
import { IDimensionNode } from '../kb3d-models';
import { KbVector } from '../primitives';
import { Token } from '../token';
import { AnnotationNode } from './annotation-node';

@Kb3dModel<DimensionNode>({
    token: Token.DimensionNode,
})
export class DimensionNode extends AnnotationNode implements IDimensionNode {
    public constructor() {
        super();
    }

    lineCapStyle: eDimensionLineCapStyle;
    axis: eDimensionAxis;
    lineThickness: number;
    dimensionGap: number;
    labelOffset: KbVector;
    dimensionUnitPrecision: number;
    scaleWithCamera: boolean;
    scaleLinesWithCamera: boolean;
    maxClampingDistance: number;
    @NodeReference(Connector, 'position')
    target2Id?: string;
}
